import kebabcaseKeys from 'kebabcase-keys';

import {
  authorizedPyInstance as py,
} from '~/utils/api/instances';

const log = {
  create: p =>
    py
      .post(
        '/api/data/public/tbl-identity-action-log',
        kebabcaseKeys(p, { deep: true }),
      ),
  list: () =>
    py
      .get('/api/data/public/tbl-identity-action-log'),
};

export default log;
